export default {
  getMainMenu: state => state.mainMenu,
  getAlert: state => state.alert,
  getZIndex: state => state.zIndex,
  getConfirm: state => state.confirm,
  getLoading: state => state.loading,
  getToast: state => state.toast,
  getSelectImgWin: state => state.selectImgWin,
  getSelectVideoWin: state => state.selectVideoWin,
  getSelectAudioWin: state => state.selectAudioWin,
  getSelectArticleWin: state => state.selectArticleWin,
  getGroups: state => state.groups,
  getPlayer: state => state.player,
  getLoginUser: state => state.loginUser,
  getMenuHide: state => state.menuHide,
  getPermission: state => state.permission,
  currentGroup: state => state.currentGroup
}
